const ru = {
  translation: {
    common: {
      notfound: "По вашему запросу ничего не найдено",
      calendar: {
        today: "Сегодня",
        yesterday: "Вчера",
        thisWeek: "Эта неделя",
        lastWeek: "Прошлая неделя",
        thisMonth: "Этот месяц",
        lastMonth: "Прошлый месяц",
        upToday: "предыдущих дней",
        fromToday: "следующих дней",
      },
    },
    pages: {
      admin: {
        admin: "Администрирование",
        apiLog: "Журнал API",
        eventLog: "Журнал событий",
      },
      guide: "Руководство пользователя",
      license: "Лицензия",
      support: "Тех. поддержка",
    },
    admin: {
      activeSessions: {
        title: "Активные сессии",
        sort_byCreatedASC: "Сначала старые",
        sort_byCreatedDESC: "Сначала новые",
        sort_byName: "По имени сеанса",
        filter_userid: "Пользователь",
        filter_created: "Дата начала сеанса",
        filter_updated: "Дата последней активности",
        filter_state: "Флаги состояния (state)",
        filter_status: "Флаги статуса (status)",
      },
      eventLog: {
        title: "Журнал событий",
        sort_byCreatedASC: "Сначала старые",
        sort_byCreatedDESC: "Сначала новые",
        filter_type: "По типу",
        filter_datetime: "По дате",
      },
      apiLog: {
        title: "Журнал запросов API",
        sort_byCreatedASC: "Сначала старые",
        sort_byCreatedDESC: "Сначала новые",
        filter_datetime: "По дате",
      },
    },
    swal: {
      yep: "Да, хорошо",
      nope: "Нет, отмена",
      ok: "OK",
      cancell: "Отмена",
    },
    error: {
      notFound: {
        title: "Страница не найдена",
        message: "Извините, запрашиваемая вами страница не найдена",
      },
    },
  },
};
export default ru;
